var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettlementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#0226A3",
    fillOpacity: 0.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8361 9.91748C18.4196 9.91492 17.0214 10.2379 15.7495 10.8614C14.4776 11.485 13.3659 12.3925 12.5004 13.5138C11.6349 14.6352 11.0386 15.9404 10.7575 17.3288C10.4765 18.7172 10.5182 20.1516 10.8795 21.5213C11.2408 22.891 11.912 24.1594 12.8413 25.2285C13.7706 26.2976 14.9331 27.1389 16.2391 27.6875C17.5451 28.236 18.9597 28.4771 20.3737 28.3922C21.7877 28.3073 23.1633 27.8986 24.3943 27.1977H24.459H24.5052C26.2853 26.1844 27.6784 24.6087 28.466 22.7179C29.2536 20.8271 29.3911 18.7283 28.8568 16.751C28.3225 14.7737 27.1468 13.0297 25.5141 11.7929C23.8814 10.5561 21.8843 9.89642 19.8361 9.91748ZM20.7607 11.8313C22.388 12.0377 23.9005 12.7791 25.0603 13.939C26.2202 15.0988 26.9616 16.6113 27.168 18.2386H20.7607V11.8313ZM19.8361 26.5597C17.9634 26.5469 16.1653 25.8243 14.8046 24.5375C13.4439 23.2508 12.6219 21.4958 12.5046 19.6267C12.3873 17.7577 12.9833 15.9137 14.1724 14.4669C15.3615 13.0201 17.0552 12.0782 18.9116 11.8313V19.1632C18.9152 19.2739 18.9371 19.3832 18.9763 19.4868V19.5607V19.6255L22.6746 25.9772C21.7775 26.3612 20.8119 26.5593 19.8361 26.5597ZM24.3018 25.0434L21.4357 20.0877H27.168C27.0435 21.0628 26.7259 22.0032 26.2338 22.8541C25.7417 23.705 25.0849 24.4493 24.3018 25.0434Z",
    fill: "#0226A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlementIcon);
export default __webpack_public_path__ + "static/media/settlement-icon.1894851760ed6da9bef255038193ba24.svg";
export { ForwardRef as ReactComponent };